/**
 * temporalParser.js
 *
 * Lightweight temporal intent parser for Kevia.
 * Maps natural language time references to a canonical horizon,
 * enabling correct tool selection (e.g. "próxima visita" → get_next_visit,
 * not get_today_visits).
 *
 * Pure function — no side effects, no external deps.
 */

const TEMPORAL_PATTERNS = [
  {
    horizon: "today",
    patterns: [
      /\bhoy\b/i,
      /\bde hoy\b/i,
      /\bpara hoy\b/i,
    ],
  },
  {
    horizon: "tomorrow",
    patterns: [
      /\bma[ñn]ana\b/i,
    ],
  },
  {
    horizon: "next",
    patterns: [
      /\bpr[oó]xim[ao]\b/i,
      /\bla\s+siguiente\b/i,
      /\bel\s+siguiente\b/i,
      /\bque\s+viene\b/i,
      /\bentrante\b/i,
      /\bcu[aá]l\s+(es\s+)?mi\s+pr[oó]xim[ao]/i,
    ],
  },
  {
    horizon: "week",
    patterns: [
      /\besta\s+semana\b/i,
      /\bsemana\s+actual\b/i,
      /\bpr[oó]ximos?\s+d[ií]as\b/i,
      /\bla\s+semana\b/i,
    ],
  },
  {
    horizon: "month",
    patterns: [
      /\beste\s+mes\b/i,
      /\bmes\s+actual\b/i,
      /\bpr[oó]ximo\s+mes\b/i,
    ],
  },
  {
    horizon: "recent",
    patterns: [
      /[uú]ltim[ao]s?/i,
      /\breciente\b/i,
      /\bayer\b/i,
      /\bsemana\s+pasada\b/i,
      /\bmes\s+pasado\b/i,
      /\banteriorm?e?n?t?e?\b/i,
    ],
  },
  {
    horizon: "pending",
    patterns: [
      /\bpendientes?\b/i,
      /\bsin\s+realizar\b/i,
      /\bpor\s+completar\b/i,
      /\bpor\s+hacer\b/i,
    ],
  },
  {
    horizon: "active",
    patterns: [
      /\bactiv[ao]s?\b/i,
      /\bvigentes?\b/i,
      /\bsin\s+responder\b/i,
      /\babi[eé]rt[ao]s?\b/i,
      /\ben\s+curso\b/i,
    ],
  },
];

/**
 * Parse temporal horizon from user message text.
 * Returns the first matching horizon, or null.
 *
 * @param {string} text
 * @returns {"today"|"tomorrow"|"next"|"week"|"month"|"recent"|"pending"|"active"|null}
 */
export function parseTemporalIntent(text) {
  if (!text) return null;
  for (const { horizon, patterns } of TEMPORAL_PATTERNS) {
    if (patterns.some((p) => p.test(text))) return horizon;
  }
  return null;
}
